import React from 'react'
import { ToastContainer } from 'react-toastify'
const ToastBox = () => {
  return (
    <ToastContainer
    position="top-right"
    autoClose={5000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    theme='dark'
    pauseOnFocusLoss
    draggable
    pauseOnHover
  />
  )
}

export default ToastBox;